import React, { useEffect, useState } from 'react'
import { Modal, Form, Input, Typography, Select, Result, Row, Button, Popconfirm } from 'antd';
import '../index.less';

const { Text } = Typography;
const { Search } = Input;

const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 12
  },
};

const UpdateSource = (props) => {

  const { visible, onCancel, loading, dispatch, form, info, onOk, employees } = props;
  const { getFieldDecorator, validateFields, setFieldsValue } = form;

  const handleOk = (value) => {
    validateFields((errors, values) => {
      if (errors) {
        return
      }
      onOk && onOk({ id: info.id, ...values });
    })
  }

  return (
    <Modal
      title='编辑协助心理师'
      visible={visible}
      onCancel={() => { onCancel && onCancel() }}
      onOk={handleOk}
      maskClosable={false}
      destroyOnClose
    >
      <Form {...formItemLayout} style={{ marginTop: 24 }}>
        <Form.Item label='协助心理师'>
          {getFieldDecorator('assistantCreatedBy', {
            initialValue: info && (info.assistantCreatedByUser || {}).id,
            rules: [{ required: true, message: '协助心理师必选' }]
          })(<Select>
            {employees && employees.map((item) => {
              return <Select.Option value={item.id} key={item.id}>{item.nickname}</Select.Option>
            })}
          </Select>)}
        </Form.Item>
      </Form>
    </Modal>
  )
}


export default Form.create()(UpdateSource)